import { createListApiSchema } from '../General/schemas';
import z from 'zod';

export const siteSchema = z
	.object({
		id: z.string().length(4),
		name: z.string().optional(),
		description: z.string().optional(),
		emergencyMode: z.boolean().optional(),
		emergencyModeEnabledBy: z.string().optional(),
		// Maximum grace period (minutes) allowed at this site; caps the event type's grace.
		// Unset = no cap (the per-site override is opt-in).
		allowMinutesPre: z.number().optional(),
		allowMinutesPost: z.number().optional(),
		address: z
			.object({
				address: z.string().optional(),
				postalCode: z.string().optional(),
				city: z.string().optional(),
				country: z.string().optional(),
			})
			.optional(),
		timezone: z.string(),
		location: z
			.object({
				lat: z.number(),
				lng: z.number(),
			})
			.optional(),
		keywords: z.string(),
		settings: z.any(),
	})
	.describe('Site');

export const siteCompliancySchema = z.object({
	compliant: z.number(),
	pending: z.number(),
	warning: z.number(),
	expired: z.number(),
	review: z.number(),
	blocked: z.number(),
});

export const hasReviewsAndApprovalsSchema = z.object({
	hasReviews: z.boolean(),
	hasApprovals: z.boolean(),
});

export const sitesApiResponseSchema = createListApiSchema(siteSchema).describe('SiteList');

export const inhoudingsplichtOverviewSchema = z.object({
	nonApplicable: z.number(), // be-retainment-finance check and be-retainment-nsso check return with success.
	applicable: z.number(), // Inhoudingsplicht is applicable. be-retainment-finance check or be-retainment-nsso check returns with a warning.
	needsManualCheck: z.number(), // be-retainment-finance check and be-retainment-nsso check return with unknown.
});

export const siteOverviewSchema = z.object({
	site: z.any(),
	siteId: z.string(),
	compliancy: siteCompliancySchema,
	stats: z.object({
		currentlyCheckedIn: z.number(),
		checkedInToday: z.number(),
		checkedInLastHour: z.number(),
	}),
	overviewEvents: z.object({
		ongoingCount: z.number(),
		startTodayCount: z.number(),
		startTomorrowCount: z.number(),
	}),
	dailyUsersData: z.array(
		z.object({
			date: z.string(),
			uniqueCheckins: z.number(),
			label: z.string(),
		}),
	),
	inhoudingsplichtOverview: inhoudingsplichtOverviewSchema,
});
